<template>
  <header>
    <router-link 
      class="logo" 
      to="/"
    >
      <img 
        src="@/assets/logo.png" 
        alt="磐石保經" 
      />
    </router-link>
    <SignInMenu 
      v-if="isLogin"
      v-bind="{handleLogout, fullName}"
    />
    <LoginHelper v-else />
  </header>
</template>

<script>
  import SignInMenu from '@/components/auth/login/SignInMenu';
  import LoginHelper from '@/components/auth/login/LoginHelper';
  import { LOGOUT_REQUEST_ACTION } from '@/store/modules/user/constants';

  export default {
    components: {
      SignInMenu,
      LoginHelper,
    },
    computed: {
      isLogin() {
        return this.$store.state.user.isLogin;
      },
      fullName() {
        return this.$store.getters.userInfo.fullName;
      }
    },
    methods: {
      handleLogout() {
        this.$store.dispatch(LOGOUT_REQUEST_ACTION);
      }
    }
  };
</script>